/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicTabletServicesQueryResponse, GetApiPublicTabletServicesQueryParams, GetApiPublicTabletServices400, GetApiPublicTabletServices403, GetApiPublicTabletServices404, GetApiPublicTabletServices500 } from "../entities/GetApiPublicTabletServices";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getApiPublicTabletServices } from "../api/getApiPublicTabletServices";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getApiPublicTabletServicesQueryKey = (params: GetApiPublicTabletServicesQueryParams) => [{ url: '/api/public/tablet/services' }, ...(params ? [params] : [])] as const

export type GetApiPublicTabletServicesQueryKey = ReturnType<typeof getApiPublicTabletServicesQueryKey>

export function getApiPublicTabletServicesQueryOptions(params: GetApiPublicTabletServicesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getApiPublicTabletServicesQueryKey(params)
        return queryOptions<GetApiPublicTabletServicesQueryResponse, ResponseErrorConfig<GetApiPublicTabletServices400 | GetApiPublicTabletServices403 | GetApiPublicTabletServices404 | GetApiPublicTabletServices500>, GetApiPublicTabletServicesQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getApiPublicTabletServices(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Активные неудалённые услуги компании выбранного доступного филиала
 * @summary Получить услуги для планшета
 * {@link /api/public/tablet/services}
 */
export function useGetApiPublicTabletServices<TData = GetApiPublicTabletServicesQueryResponse, TQueryData = GetApiPublicTabletServicesQueryResponse, TQueryKey extends QueryKey = GetApiPublicTabletServicesQueryKey>(params: GetApiPublicTabletServicesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetApiPublicTabletServicesQueryResponse, ResponseErrorConfig<GetApiPublicTabletServices400 | GetApiPublicTabletServices403 | GetApiPublicTabletServices404 | GetApiPublicTabletServices500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getApiPublicTabletServicesQueryKey(params)
         

         const query = useQuery({
          ...getApiPublicTabletServicesQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetApiPublicTabletServices400 | GetApiPublicTabletServices403 | GetApiPublicTabletServices404 | GetApiPublicTabletServices500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}